<app-breadcrumb [master]="'Administracja'" [parentName]="'Użytkownicy'" [name]="'Szczegóły'"></app-breadcrumb>
<mat-tab-group   [(selectedIndex)]="selectedTab">
  <mat-tab label="Dane">
    <app-user-details-view *ngIf="!modify" [user]="user" (modifyClicked)="modify = true" (avatarChanged)="loadUser()"></app-user-details-view>
    <app-user-add *ngIf="modify" [user]="user" (closeModification)="modify = false; loadUser()"></app-user-add>
  </mat-tab>

  <mat-tab label="Uprawnienia ASF24">
    <div *ngIf="userObject" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column" class="user-permissions">
      <div fxFlex="50" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="15px">
        <div fxLayout="row" *ngIf="userObject.department">
          <mat-card>
            <h3>Uprawnienia działu (pracownik)</h3>

            <app-permissions [disabled]="true" [currentPermissions]="userObject.department.employeePermissions"></app-permissions>
          </mat-card>
        </div>

        <div fxLayout="row">
          <mat-card>
            <h3>Uprawnienia indywidualne użytkownika</h3>

            <app-permissions [disabled]="!(userPermissions | async).user.write" [permissionsForm]="userPermissionsForm"
                             [currentPermissions]="userObject.permissions"></app-permissions>

            <button *ngIf="(userPermissions | async).user.write" (click)="savePermissions()"
                    mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
          </mat-card>
        </div>

        <div fxLayout="row" >
          <mat-card fxFlex="100">
            <h3>Blokada pobierania raportów</h3>


            <div fxLayout="row">
              <div fxFlex="100">
                <app-dict fxFlex="100" [label]="'Blokada pobierania raportów'"
                          [dictType]="'permissions_type'"
                          [control]="reportPermissionsControl"
                          [required]="false"
                          [returnKey]="true"
                          [multiple]="true"></app-dict>
              </div>
            </div>

            <button *ngIf="(userPermissions | async).user.write" (click)="saveReportPermissions()"
                    mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
          </mat-card>
        </div>

      </div>

      <div fxFlex="50" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="15px">

        <div fxLayout="row" *ngFor="let department of userObject.supervisors;">
          <mat-card>
            <h3>Uprawnienia dział (przełożony) - {{department.name}}</h3>

            <app-permissions [disabled]="true" [currentPermissions]="department.supervisorPermissions"></app-permissions>
          </mat-card>
        </div>

        <div fxLayout="row" *ngIf="userSummaryPermissions">
          <div fxFlex="100">
            <mat-card>
                  <h3>Podsumowanie uprawnień</h3>

                  <app-permissions [disabled]="true" [currentPermissions]="userSummaryPermissions"></app-permissions>

                  <app-detail header="Blokada pobierania raportów ">
                    <mat-chip-list>
                      <ng-container *ngFor="let val of userRaporValue">
                        <mat-chip color="accent" selected>{{val}}</mat-chip>
                      </ng-container>
                    </mat-chip-list>
                  </app-detail>

            </mat-card>
          </div>
        </div>
      </div>
    </div>

  </mat-tab>


  <mat-tab label="Uprawnienia 360">
    <mat-card  fxLayoutGap="15px">
      <div fxLayout="row">
        <h3>Uprawnienia</h3>
      </div>
      <div >
        <div  fxFlex="100">


          <div fxLayout="row" fxLayoutGap="15px" *ngIf="permissionRegional.length > 0">
            <div fxFlex="100">
              <app-detail header="Regionalni">
                <mat-chip-list>
                  <ng-container *ngFor="let regional of permissionRegional">
                    <mat-chip  selected>{{regional.fullName}}</mat-chip>
                  </ng-container>
                </mat-chip-list>
              </app-detail>
            </div>
          </div>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="50">
          <app-detail-bool fxFlex="100" header="Partner" [value]="!!userObject?.partnerId"></app-detail-bool>
        </div>
        <div  fxFlex="50">
          <app-detail-bool fxFlex="100" header="OFWCA" [value]="!!userObject?.ofwcaId"></app-detail-bool>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="50">
          <app-detail-bool fxFlex="100" header="Aktualności produktowe" [value]="userObject?.permissionPartnerCompetition"></app-detail-bool>
        </div>
        <div  fxFlex="50">
          <app-detail-bool fxFlex="100" header="Aktualności produktowe" [value]="userObject?.permissionOfwcaCompetition"></app-detail-bool>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="50">
        </div>
        <div  fxFlex="50">
          <app-detail-bool fxFlex="100" header="Aktualności produktowe " [value]="userObject?.permissionProduct"></app-detail-bool>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="100">
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="permissionTagPartner.length > 0">
            <div fxFlex="100">
              <app-detail header=" Tagi Partnera">
                <mat-chip-list>
                  <ng-container *ngFor="let tagPartner of permissionTagPartner">
                    <mat-chip  selected>{{tagPartner.name}}</mat-chip>
                  </ng-container>
                </mat-chip-list>
              </app-detail>
            </div>
          </div>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="100">
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="permissionContractType.length > 0">
            <div fxFlex="100">
              <app-detail header="Typ umowy">
                <mat-chip-list>
                  <ng-container *ngFor="let contractType of permissionContractType">
                    <mat-chip  selected>{{contractType.name}}</mat-chip>
                  </ng-container>
                </mat-chip-list>
              </app-detail>
            </div>
          </div>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="100">
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="permissionIddTrainingStatus.length > 0">
            <div fxFlex="100">
              <app-detail header="Statusy szkoleń IDD">
                <mat-chip-list>
                  <ng-container *ngFor="let status of permissionIddTrainingStatus">
                    <mat-chip selected>{{status.name}}</mat-chip>
                  </ng-container>
                </mat-chip-list>
              </app-detail>
            </div>
          </div>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="100">
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="permissionRegistration.length > 0">
            <div fxFlex="100">
              <app-detail header=" Rejestracje">
                <mat-chip-list>
                  <ng-container *ngFor="let ic of permissionRegistration">
                    <mat-chip  selected>{{ic.name}}</mat-chip>
                  </ng-container>
                </mat-chip-list>
              </app-detail>
            </div>
          </div>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="100">
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="permissionTag.length > 0">
            <div fxFlex="100">
              <app-detail header="Grupy uprawnień">
                <mat-chip-list>
                  <ng-container *ngFor="let tag of permissionTag">
                    <mat-chip selected>{{tag.name}}</mat-chip>
                  </ng-container>
                </mat-chip-list>
              </app-detail>
            </div>
          </div>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="100">
        </div>
      </div>

      <div fxLayoutGap="15px">
          <app-crm-user-permissions-list  [user]="user"></app-crm-user-permissions-list>
      </div>
    </mat-card>
  </mat-tab>

  <mat-tab label="Uprawnienia Aplikacji">

    <div *ngIf="userObject" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column" class="user-permissions">
      <div fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="15px">

        <mat-card>
          <h3>Aplikacje</h3>

          <app-applications
            [disabled]="!(userPermissions | async).user.write"
            [applicationsForm]="userPermissionsApplicationForm"
            [currentApplications]="userObject.applications">
          </app-applications>

          <button
            *ngIf="(userPermissions | async).user.write"
            (click)="savePermissionsApplication()"
            mat-stroked-button
            color="primary">
            <mat-icon>save</mat-icon>
            <span> Zapisz</span>
          </button>
        </mat-card>

      </div>
    </div>


    <div *ngIf="userObject?.department" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column" class="user-permissions">
      <div fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="15px">

        <mat-card>
          <h3>Uprawnienia aplikacji z działu</h3>

          <p class="application-permission-info">
            Użytkownik jest przypisany do działu:
            <strong>{{ userObject.department.name }}</strong>.
            Obowiązują uprawnienia aplikacji ustawione dla pracownika tego działu.
          </p>

          <app-application-permission
            [currentApplicationPermissions]="getDepartmentEmployeeApplicationPermissions()"
            [assignmentContext]="'department'"
            [disabled]="true">
          </app-application-permission>
        </mat-card>

      </div>
    </div>


    <div
      *ngIf="userObject?.supervisors?.length"
      fxLayout="row"
      fxLayoutGap="15px"
      fxLayout.lt-md="column"
      class="user-permissions">

      <div fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="15px">

        <mat-card *ngFor="let department of userObject.supervisors">
          <h3>Uprawnienia aplikacji jako przełożony działu - {{ department.name }}</h3>

          <p class="application-permission-info">
            Te uprawnienia obowiązują użytkownika jako przełożonego wskazanego działu.
          </p>

          <app-application-permission
            [currentApplicationPermissions]="getDepartmentSupervisorApplicationPermissions(department)"
            [assignmentContext]="'department'"
            [disabled]="true">
          </app-application-permission>
        </mat-card>

      </div>
    </div>


    <div *ngIf="userObject" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-md="column" class="user-permissions">
      <div fxFlex="100" fxFlex.lt-md="100" fxLayout="column" fxLayoutGap="15px">

        <mat-card>
          <h3>Indywidualne uprawnienia aplikacji</h3>

          <p class="application-permission-info">
            Część uprawnień aplikacji może wynikać z działu, ale uprawnienia oznaczone jako indywidualne
            muszą być ustawione bezpośrednio na użytkowniku.
          </p>

          <app-application-permission
            [applicationPermissionsForm]="userApplicationPermissionsForm"
            [currentApplications]="userObject.applications"
            [currentApplicationPermissions]="userObject.applicationPermissions"
            [assignmentContext]="'user'"
            [disabled]="!(userPermissions | async).user.write">
          </app-application-permission>

          <button
            *ngIf="(userPermissions | async).user.write"
            (click)="saveApplicationPermissions()"
            mat-stroked-button
            color="primary">
            <mat-icon>save</mat-icon>
            <span> Zapisz</span>
          </button>
        </mat-card>

      </div>
    </div>

  </mat-tab>

  <mat-tab *ngIf="(userPermissions | async).user.admin_root" label="Historia Logowania">
    <ng-template matTabContent>
      <app-login-log-list [user]="user"></app-login-log-list>
    </ng-template>
  </mat-tab>

  <mat-tab label="Historia zmian">
    <ng-template matTabContent>
      <app-log-list [user]="user"></app-log-list>
    </ng-template>
  </mat-tab>

<!--  <mat-tab label="Uprawnienia ASF360" *ngIf="userObject.activeASF360">-->
<!--  </mat-tab>-->
</mat-tab-group>
